import { Ds } from "@accurx/design";
import styled from "styled-components";

export const StyledLink = styled(Ds.Link)`
    svg {
        width: 20px;
        height: 20px;
    }
`;
